import Controller from '@ember/controller';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';

export default class AuthenticatedTuitionAssistanceProgramBuilderReviewController extends Controller {
  @service declare router: RouterService;
  @service declare store: StoreService;
}
